var map = {
	"./project/close.svg": "b44b",
	"./project/cross-icon.svg": "d5c5",
	"./project/down-arrow.svg": "d588",
	"./project/flag.svg": "6934",
	"./project/pin.svg": "f500",
	"./project/search-icon.svg": "a1cf",
	"./project/up-arrow.svg": "449c",
	"./project/user.svg": "116d",
	"./template/sample-logo.svg": "2bfb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9c4a";